import { Resource, Texture } from "pixi.js";
import { getGameImages } from "../../../helpers";
import { isMobile } from "../../../../helpers";

export const jackPotSymbols: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const jackpotIcons: { [key: string]: string } = {
    1: 'clubs',
    2: 'diamond',
    3: 'heart',
    4: 'spades',
};


export const jackPotItemsHelper = (): { jackPotItemEnum: any[], jackpotBg: Texture<Resource> } => {
    const { jackpotBg, jackPotHeartSymbolCollectStep0, jackPotSpadeSymbolCollectStep0, jackPotClubsSymbolCollectStep0, jackPotDiamondSymbolCollectStep0, } = getGameImages();
    const jackPotItemEnum: any[] = [
        {
            id: 3,
            x: isMobile() ? 110 : 170,
            y: isMobile() ? 132 : 180,
            isWin: false,
            type: 'heartAmount',
            name: 'JackPotHeartSectionContainer',
            image: jackPotHeartSymbolCollectStep0,
            positions: isMobile()
                ? [
                    { x: 85, y: 127, scale: 0.3 },
                    { x: 135, y: 127, scale: 0.3 },
                    { x: 110, y: 127, scale: 0.4 },
                ]
                : [
                    { x: 113, y: 177 },
                    { x: 227, y: 177 },
                    { x: 170, y: 177 },
                ],
        },
        {
            id: 4,
            x: isMobile() ? 428 : 1263,
            y: isMobile() ? 132 : 180,
            isWin: false,
            type: 'spadeAmount',
            name: 'JackPotSpadeSectionContainer',
            image: jackPotSpadeSymbolCollectStep0,
            positions: isMobile()
                ? [
                    { x: 402, y: 127, scale: 0.3 },
                    { x: 455, y: 127, scale: 0.3 },
                    { x: 429, y: 131, scale: 0.4 },
                ]
                : [
                    { x: 1207, y: 171 },
                    { x: 1317, y: 171 },
                    { x: 1263, y: 171 },
                ],
        },
        {
            id: 1,
            x: isMobile() ? 157 : 281,
            y: isMobile() ? 230 : 374,
            isWin: false,
            type: 'clubAmount',
            name: 'JackPotClubsSectionContainer',
            image: jackPotClubsSymbolCollectStep0,
            positions: isMobile()
                ? [
                    { x: 130, y: 227, scale: 0.3 },
                    { x: 185, y: 227, scale: 0.3 },
                    { x: 157, y: 227, scale: 0.4 },
                ]
                : [
                    { x: 224, y: 369 },
                    { x: 338, y: 369 },
                    { x: 280, y: 369 },
                ],
        },
        {
            id: 2,
            x: isMobile() ? 381 : 1136,
            y: isMobile() ? 230 : 374,
            isWin: false,
            type: 'diamondAmount',
            name: 'JackPotDiamondSectionContainer',
            image: jackPotDiamondSymbolCollectStep0,
            positions: isMobile()
                ? [
                    { x: 355, y: 227, scale: 0.3 },
                    { x: 406, y: 227, scale: 0.3 },
                    { x: 381, y: 227, scale: 0.4 },
                ]
                : [
                    { x: 1082, y: 370 },
                    { x: 1190, y: 370 },
                    { x: 1136, y: 370 },
                ],
        },
    ]

    return { jackPotItemEnum, jackpotBg }
}